export const optionsToIds = options => (Array.isArray(options) ? options?.map(i => i.id) : [options?.id]);

export function filterSitesByStudyIdsAndSsus(ssus, study, sites) {
  const studyIds = optionsToIds(study);
  const filteredSiteIds = ssus?.filter(ss => studyIds.includes(ss.studyIdentifier))?.map(ss => ss.siteIdentifier);
  return sites?.filter(s => filteredSiteIds.includes(s.id));
}

export function filterSitesByStudyIdsAndCanceledSsus(study, sites, ssus) {
  const studyIds = optionsToIds(study);
  const filteredSiteIds = ssus
    ?.filter(ss => studyIds.includes(ss.studyIdentifier) && ss.siteStatus !== 'Canceled')
    ?.map(ss => ss.siteIdentifier);
  return sites?.filter(s => filteredSiteIds.includes(s.id));
}

export function filterTherapeuticAreasBasedOnSelectedStudyIds(therapeuticAreas, selectedStudies, ssus) {
  const selectedStudyIds = optionsToIds(selectedStudies);
  const filteredTherapeuticAreas =
    ssus?.filter(ss => selectedStudyIds.includes(ss.studyIdentifier)).map(ss => ss.study.therapeuticArea) || [];
  return therapeuticAreas.filter(t => filteredTherapeuticAreas.includes(t?.name));
}

export function filterStudiesBasedOnSiteIds(studies, sites, ssus) {
  const siteIds = optionsToIds(sites);
  const filteredStudyIds = ssus.filter(ss => siteIds.includes(ss.siteIdentifier)).map(ss => ss.studyIdentifier);
  return studies.filter(s => filteredStudyIds.includes(s.id));
}
